<script setup lang="ts">
const route = useRoute()
const publicPaths = ['/assets/'] // TODO: Add paths that skips guest login
const preferencesStore = usePreferencesStore()

onMounted(() => {
  // Third-party tags wait for hydration and an idle main thread rather than competing with them.
  const integrationScripts = [generateOptimizelyEntryScript(), generateBarillianceScript(), generateTradeDeskScript()]
  onNuxtReady(() => injectClientSideScripts(integrationScripts))
  // Initialize the Heap.io SDK
  setupHeapAnalytics()

  // Link Salesforce Customer ID to analytics platforms using the shared composable
  const { linkCustomerId } = useAnalyticsIdentity()
  linkCustomerId()
})

// These pages read the basket or wishlist as they mount; everywhere else renders without waiting.
const pathsNeedingLayoutStores = ['/my-bag', '/wishlist']

if (import.meta.client && !publicPaths.includes(route.path)) {
  const { $braze } = useNuxtApp()
  const edmToken = route.query?.edm_token
  if (edmToken) {
    verifyBrazeEdmParam(String(edmToken))
      .then(({ cid }) => {
        if (cid) {
          $braze.sdk.changeUser(cid)
        }
        // The shopper may have navigated on while this was verifying.
        if (!route.query?.edm_token) return
        const queryParams = { ...route.query }

        delete queryParams.edm_token

        navigateTo({ query: queryParams })
      })
      .catch(() => console.error('Error verifying Braze EDM token'))
  }

  const layoutStores = initLayoutStores().catch(() => undefined)
  if (pathsNeedingLayoutStores.includes(route.path.replace(/^\/fr(?=\/)/, '').replace(/\/$/, ''))) {
    await layoutStores
  }
}

useHead(() => {
  const googleVerificationToken = preferencesStore.site?.googleVerificationToken
  if (import.meta.server && googleVerificationToken) {
    return {
      meta: [
        {
          key: 'google-site-verification',
          name: 'google-site-verification',
          content: googleVerificationToken,
        },
      ],
    }
  }
  return {}
})
</script>

<template>
  <Header />
  <main id="main">
    <PageContentSlot :slug="route.path" section="header" />
    <slot />
    <GlobalIncludes />
  </main>
  <PageContentSlot :slug="route.path" section="footer" />
  <Footer />
</template>
